/*
  Upsell "segundo anillo" del carro lateral (snippets/cart-upsell-anillo.liquid).
  El cliente elige anillo, piedra y talla, y se agrega al carrito sin salir del carro.
*/
// Talla virtual (igual que en la página de producto, anillos de la colección "anillos-pedido"):
// se agrega con la primera talla disponible + la propiedad "Talla Especial: No sé la talla".
var UPSELL_NO_SIZE = 'No sé la talla';

if (!customElements.get('cart-upsell')) {
  customElements.define(
    'cart-upsell',
    class CartUpsell extends HTMLElement {
      connectedCallback() {
        const dataEl = this.querySelector('[data-upsell-products]');
        if (!dataEl) return;
        this.products = JSON.parse(dataEl.textContent);
        this.percent = Number(this.dataset.percent) || 0;

        this.nameEl = this.querySelector('[data-upsell-name]');
        this.priceEl = this.querySelector('[data-upsell-price]');
        this.compareEl = this.querySelector('[data-upsell-compare]');
        this.stonesEl = this.querySelector('[data-upsell-stones]');
        this.sizeEl = this.querySelector('[data-upsell-size]');
        this.errorEl = this.querySelector('[data-upsell-error]');
        this.addBtn = this.querySelector('[data-upsell-add]');
        this.addText = this.querySelector('[data-upsell-add-text]');
        this.addLabel = this.addText.textContent.trim();

        this.hintEl = document.createElement('p');
        this.hintEl.className = 'cart-upsell__hint';
        this.hintEl.textContent = 'Te contactaremos después de tu compra para definir la talla perfecta.';
        this.hintEl.hidden = true;
        this.sizeEl.parentElement.after(this.hintEl);

        this.querySelectorAll('.cart-upsell__ring').forEach((ring) => {
          ring.addEventListener('click', () => this.selectProduct(Number(ring.dataset.index)));
        });
        this.stonesEl.addEventListener('click', (e) => {
          const pill = e.target.closest('.cart-upsell__stone');
          if (!pill) return;
          this.stone = pill.dataset.value;
          this.render();
        });
        // El carro de Dawn (cart.js) escucha los "change" dentro del carro como si fueran
        // cambios de cantidad; se detienen aquí para que no valide la lista de tallas.
        ['change', 'input'].forEach((type) =>
          this.addEventListener(type, (e) => e.stopPropagation())
        );
        this.sizeEl.addEventListener('change', () => {
          this.size = this.sizeEl.value;
          this.hideError();
          this.render();
          // En celular el botón puede quedar bajo el pie del carro: se muestra al elegir talla
          this.addBtn.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        });
        this.addBtn.addEventListener('click', () => this.add());

        this.selectProduct(0);
      }

      // Índices de las opciones de talla y piedra del producto
      optionIndex(product, regex) {
        return product.options.findIndex((name) => regex.test(name));
      }

      selectProduct(index) {
        this.product = this.products[index];
        if (!this.product) return;
        this.sizeIdx = this.optionIndex(this.product, /talla|tamaño|size/i);
        this.stoneIdx = this.optionIndex(this.product, /piedra|gema|stone|gem/i);

        // Piedra por defecto: la de la primera variante disponible
        const first = this.product.variants.find((v) => v.available) || this.product.variants[0];
        this.stone = this.stoneIdx >= 0 ? first.options[this.stoneIdx] : null;
        this.size = '';

        this.querySelectorAll('.cart-upsell__ring').forEach((ring) => {
          const selected = Number(ring.dataset.index) === index;
          ring.classList.toggle('is-selected', selected);
          ring.setAttribute('aria-checked', selected);
        });
        this.nameEl.textContent = this.product.title;
        this.hideError();
        this.render();
      }

      uniqueValues(idx) {
        return [...new Set(this.product.variants.map((v) => v.options[idx]))];
      }

      // Variante que coincide con piedra + talla (las demás opciones, ej. "Modelo", se toman de la primera disponible)
      findVariant(size = this.size) {
        if (size === UPSELL_NO_SIZE) {
          return this.product.variants.find(
            (v) => v.available && (this.stoneIdx < 0 || v.options[this.stoneIdx] === this.stone)
          );
        }
        return this.product.variants.find(
          (v) =>
            (this.stoneIdx < 0 || v.options[this.stoneIdx] === this.stone) &&
            (this.sizeIdx < 0 || v.options[this.sizeIdx] === size) &&
            v.available
        );
      }

      render() {
        // Piedras
        this.stonesEl.innerHTML = '';
        if (this.stoneIdx >= 0) {
          const stones = this.uniqueValues(this.stoneIdx);
          if (stones.length > 1) {
            stones.forEach((value) => {
              const pill = document.createElement('button');
              pill.type = 'button';
              pill.className = 'cart-upsell__stone' + (value === this.stone ? ' is-selected' : '');
              pill.dataset.value = value;
              pill.textContent = value;
              pill.setAttribute('aria-pressed', value === this.stone);
              this.stonesEl.appendChild(pill);
            });
          }
        }
        this.stonesEl.hidden = !this.stonesEl.children.length;

        // Tallas
        this.sizeEl.innerHTML = '';
        if (this.sizeIdx >= 0) {
          const placeholder = new Option('Elige talla', '');
          placeholder.disabled = true;
          this.sizeEl.appendChild(placeholder);
          if (this.product.noSize && this.findVariant(UPSELL_NO_SIZE)) {
            this.sizeEl.appendChild(new Option(UPSELL_NO_SIZE, UPSELL_NO_SIZE));
          }
          this.uniqueValues(this.sizeIdx)
            .sort((a, b) => (parseFloat(a) || 0) - (parseFloat(b) || 0))
            .forEach((value) => {
              const available = Boolean(this.findVariant(value));
              const opt = new Option(available ? value : `${value} - Agotado`, value);
              opt.disabled = !available;
              this.sizeEl.appendChild(opt);
            });
          if (this.size && !this.findVariant(this.size)) this.size = '';
          this.sizeEl.value = this.size;
          if (!this.size) placeholder.selected = true;
        }
        this.sizeEl.parentElement.hidden = this.sizeIdx < 0;
        this.hintEl.hidden = this.size !== UPSELL_NO_SIZE;

        // Precio (referencia: variante elegida o la primera disponible con esa piedra)
        const variant =
          this.findVariant() ||
          this.product.variants.find(
            (v) => v.available && (this.stoneIdx < 0 || v.options[this.stoneIdx] === this.stone)
          ) ||
          this.product.variants[0];
        const discounted = Math.round((variant.price * (100 - this.percent)) / 100);
        if (this.compareEl) this.compareEl.textContent = this.formatMoney(variant.price);
        this.priceEl.textContent = this.formatMoney(discounted);
        this.addText.textContent = `${this.addLabel} · ${this.formatMoney(discounted)}`;
      }

      formatMoney(cents) {
        return '$' + Math.round(cents / 100).toLocaleString('es-CL');
      }

      showError(message) {
        this.errorEl.textContent = message;
        this.errorEl.hidden = false;
      }

      hideError() {
        this.errorEl.hidden = true;
      }

      add() {
        if (this.addBtn.classList.contains('loading')) return;
        if (this.sizeIdx >= 0 && !this.size) {
          this.showError('Elige la talla de tu segundo anillo');
          this.sizeEl.focus();
          return;
        }
        const variant = this.findVariant();
        if (!variant) {
          this.showError('Esta combinación está agotada, elige otra');
          return;
        }

        const cart = document.querySelector('cart-drawer');
        const formData = new FormData();
        formData.append('id', variant.id);
        formData.append('quantity', 1);
        if (this.percent > 0) formData.append('properties[_upsell]', 'segundo-anillo');
        if (this.size === UPSELL_NO_SIZE) formData.append('properties[Talla Especial]', UPSELL_NO_SIZE);
        if (cart) {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
        }

        this.addBtn.classList.add('loading');
        this.hideError();

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showError(response.description || response.message || 'No se pudo agregar el anillo.');
              return;
            }
            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }
            if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'cart-upsell',
                productVariantId: variant.id,
                cartData: response,
              });
            }
            cart.classList.remove('is-empty');
            cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
            this.showError('No se pudo agregar el anillo. Intenta nuevamente.');
          })
          .finally(() => this.addBtn.classList.remove('loading'));
      }
    }
  );
}
